import Component from '../component';

export default class GoogleTagManager extends Component {
  constructor(_element) {
    super(...arguments);

    this.bindEvents();
  }

  bindEvents() {
    this.handleVisit = this.handleVisit.bind(this);

    window.$document.on('turbolinks:visit.GoogleTagManager', this.handleVisit);
  }

  unbindEvents() {
    window.$document.off('turbolinks:visit.GoogleTagManager', this.handleVisit);
  }

  /**
   * Google Tag Manager data layer events are automatically pushed at initial page load (browser refresh).
   *
   * To cover the Turbolinks behavior where the page isn't reloaded completely, we push our visit events on each
   * new page when a user navigate through the application via internal links.
   */
  handleVisit() {
    const visitDataLayer = window.dataLayer.slice();

    visitDataLayer.forEach((item, index) => {
      if (item.eventData && item.eventData.action === 'visit') {
        delete window.dataLayer[index];

        window.dataLayer.push(item);
      }
    });
  }
}
